import { z } from 'zod';

/**
 * Shared password validation schema
 * Requirements:
 * - Minimum 9 characters (more than 8)
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one digit
 */
export const passwordSchema = z
  .string()
  .min(9, 'La contraseña debe tener al menos 9 caracteres')
  .regex(/[A-Z]/, 'La contraseña debe contener al menos una letra mayúscula')
  .regex(/[a-z]/, 'La contraseña debe contener al menos una letra minúscula')
  .regex(/\d/, 'La contraseña debe contener al menos un número');
